import styled, { css } from 'styled-components';
import { Div } from '@landing_academy/shared';
import mediainjector from '../../style/mediainjector';

export const Column = styled(Div)`
  display: flex;
  flex-direction: row;
  ${mediainjector.lt667`
    justify-content: center;
    flex-direction: column;
    padding: 0 1.6em;
  `}
`;

export const Col = styled(Div)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  p {
    margin-top: 0;
    &:last-child {
      margin-bottom: 0;
    }
  }
  ${({ atf }) => atf && css`
    width: 50%;
    ${mediainjector.lt667`
      width: 100%;
      &:last-child {
        padding-bottom: 0;
      }
    `}
  `}
  ${({ left }) => left && css`
    text-align: right;
    padding-right: 1.2em;
    ${mediainjector.lt667`
      padding: 0 0 1.2em;
    `}
  `}
  ${({ right }) => right && css`
    text-align: left;
    padding-left: 1.2em;
    ${mediainjector.lt667`
      padding: 0 0 1.2em;
    `}
  `}
  ${({ center }) => center && css`
    text-align: center;
  `}
  ${({ top }) => top && css`
    align-self: flex-start;
  `}
  ${({ colTitle }) => colTitle && css`
    width: 20%;
    min-width: 20%;
    color: $main-color;
    strong {
      color: ${(props) => props.theme.brand};
    }
    ${mediainjector.lt667`
      font-size: 1.8em;
      width: 100%;
      min-width: 100%;
      text-align: center;
    `}
  `}
  ${({ colImg }) => colImg && css`
    max-width: 50%;
    ${({ small }) => small && css`
      max-width: 30%;
    `}
    img {
      width: 100%;
    }
  `}
  h4 {
    margin: 0;
  }
  ${mediainjector.lt667`
    margin: 0 auto;
    display: block;
    ul {
      text-align: left;
      max-width: 60%;
      margin: 0 auto;
    }
  `}
`;

